import { IDs } from '../../../helpers/IDs';

export function getDataYears(data: any, entities: string[], standortTid?: number): number[] {
    data = data || {};
    entities = entities || [];
    const jahre: number[] = [];
    const max: number = new Date().getFullYear();
    const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
    const min: number = +startjahr > 1900 ? startjahr : 2010;

    if (max < min) {
        return [];
    }

    for (let curJahr: number = min; curJahr <= max; ++curJahr) {
        entities.forEach((entity: string) => {
            if (jahre.indexOf(curJahr) !== -1) {
                return;
            }
            const hasData: boolean = (data[entity] || []).some((item: any) =>
                +item.jahr === curJahr
                && (typeof standortTid === 'undefined' || (typeof standortTid !== 'undefined' && item.standort_tid_orig === standortTid))
            );

            if (hasData) {
                jahre.push(curJahr);
            }
        });
    }

    return jahre;
}
